import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M0 10C0 4.477 4.477 0 10 0h28c5.523 0 10 4.477 10 10v28c0 5.523-4.477 10-10 10H10C4.477 48 0 43.523 0 38z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0068FF",
  d: "M10.969 15.81c0-1.06.908-1.92 2.029-1.92h13.526c1.12 0 2.029.86 2.029 1.92v1.92h2.143c.719 0 1.37.267 1.915.747l3.267 3.09c.508.48.79 1.132.79 1.812v4.586c.749 0 1.353.572 1.353 1.28s-.604 1.28-1.352 1.28h-1.4c-.33-2.172-2.303-3.84-4.687-3.84s-4.358 1.668-4.688 3.84h-2.798c-.33-2.172-2.304-3.84-4.688-3.84s-4.358 1.668-4.686 3.84h-.724c-1.12 0-2.03-.86-2.03-1.92zm22.995 8.317v-.748l-3.268-3.09h-2.143v3.838zm-12.17-7.076c-.36-.375-1.002-.375-1.4 0-.392.374-.392.982 0 1.322l1.654 1.595h-7.021c-.56 0-1.015.428-1.015.96s.455.96 1.015.96h7.02l-1.652 1.559c-.393.376-.393.984 0 1.323.397.408 1.04.408 1.399 0l3.382-3.198c.43-.34.43-.948 0-1.324z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#99C3FF",
  d: "M20.39 17.054c.398-.374 1.04-.374 1.4 0l3.381 3.198c.431.376.431.984 0 1.324l-3.381 3.198c-.36.408-1.002.408-1.4 0-.393-.34-.393-.947 0-1.323l1.653-1.56h-7.02c-.56 0-1.015-.427-1.015-.96 0-.531.454-.959 1.014-.959h7.021l-1.652-1.595c-.394-.34-.394-.948 0-1.323m1.395 14.114c0 1.767-1.513 3.199-3.381 3.199-1.869 0-3.382-1.432-3.382-3.2 0-1.766 1.513-3.198 3.382-3.198 1.868 0 3.381 1.432 3.381 3.199m5.411 0c0-1.767 1.513-3.199 3.381-3.199 1.869 0 3.382 1.432 3.382 3.199s-1.513 3.199-3.382 3.199c-1.868 0-3.381-1.432-3.381-3.2"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }